const administrationBase = '/administration'
const organizationsBase = '/organizations'
const virtualDevicesBase = '/virtual-devices'

const route = (base: string, relative: string) => ({
    relative,
    full: `${base}/${relative}`
})

export const routePaths = {
    home: '/',

    auth: '/auth',

    administration: {
        base: administrationBase,
        organizations: route(administrationBase, 'organizations'),
        entitlementsManager: route(administrationBase, 'entitlements-manager'),
    },

    organizations: {
        base: organizationsBase,
        details: route(organizationsBase, 'details'),
        entitlements: route(organizationsBase, 'entitlements'),
    },

    virtualDevices: {
        base: virtualDevicesBase,
        deviceModels: route(virtualDevicesBase, 'device-models'),
        deviceModelDetails: route(virtualDevicesBase, 'device-models/:id'),
        associationPolicies: route(virtualDevicesBase, 'association-policies'),
        associationPolicyDetails: route(virtualDevicesBase, 'association-policies/:id'),
    },

    errors: {
        accessDenied: '/access-denied',
        notFound: '/not-found',
        serviceUnavailable: '/service-unavailable',
    },

    droolsEditor: 'drools-editor',

} as const;